/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BigCommerceCustomerGroupRef
 */
export interface BigCommerceCustomerGroupRef {
  /**
   *
   * @type {number}
   * @memberof BigCommerceCustomerGroupRef
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof BigCommerceCustomerGroupRef
   */
  name: string;
}

/**
 * Check if a given object implements the BigCommerceCustomerGroupRef interface.
 */
export function instanceOfBigCommerceCustomerGroupRef(
  value: object,
): value is BigCommerceCustomerGroupRef {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function BigCommerceCustomerGroupRefFromJSON(
  json: any,
): BigCommerceCustomerGroupRef {
  return BigCommerceCustomerGroupRefFromJSONTyped(json, false);
}

export function BigCommerceCustomerGroupRefFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceCustomerGroupRef {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function BigCommerceCustomerGroupRefToJSON(
  json: any,
): BigCommerceCustomerGroupRef {
  return BigCommerceCustomerGroupRefToJSONTyped(json, false);
}

export function BigCommerceCustomerGroupRefToJSONTyped(
  value?: BigCommerceCustomerGroupRef | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
  };
}
